var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconDevices(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon_devices") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_devices",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(3.000000, 3.000000)",
    fill: "#E5E5E5"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-14",
    x: 0,
    y: 0,
    width: 18,
    height: 3,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-14-Copy",
    x: 15,
    y: 15,
    width: 3,
    height: 3,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-15",
    x: 0,
    y: 5,
    width: 18,
    height: 8,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-14",
    x: 0,
    y: 15,
    width: 14,
    height: 3,
    rx: 1
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDevices);
export default __webpack_public_path__ + "static/media/icon_devices.1924b8166ea4a1a258c2b8c82a38e7f8.svg";
export { ForwardRef as ReactComponent };